export default {"src":"/_next/static/media/carbeauty-fill.8179bfda.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};